import * as yup from "yup";
import { StringHelper } from "../../../../assets/utils/helpers";
import { Constants } from "../../../../assets/utils/lib/constants";
import Drawer from "../../../../assets/vfx/drawer/drawer";
import Form from "../../../../assets/vfx/form/form";
import { CommunityCategoryDto } from "../../../../services/dto";
import { DropdownOption } from "../../../../assets/vfx/controls/components/dropdown/controlDropdown";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../../assets/utils/lib";

export interface CategoryLookupProps {
  communities: DropdownOption[];
}
interface CategoryFormProps {
  data?: CommunityCategoryDto;
  loading?: boolean;
  show: boolean;
  lookups?: CategoryLookupProps;
  communityId?: string;
  disableCommunity: boolean;
  onHide: () => void;
  onSave: (values: CommunityCategoryDto) => DrawerFormSaveResult;
}

const validationSchema = yup.object().shape({
  communityId: yup.string().required("Community is required."),
  name: yup.string().required("Name is required."),
  activationDate: yup
    .date()
    .typeError("Please enter a valid date.")
    .nullable()
    .required("Activation date is required."),
});

export const CategoryForm = (props: CategoryFormProps) => {
  let category: CommunityCategoryDto | undefined = props.data;
  const header: string =
    StringHelper.whenNullOrEmpty(category?.id, Constants.emptyGuid) ===
    Constants.emptyGuid
      ? "New Category"
      : "Edit Category";

  const onSubmit = (data: CommunityCategoryDto) => {
    const updatedData: CommunityCategoryDto = {
      ...data,
    };
    return Promise.resolve(props.onSave(updatedData)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
  };
  return (
    <Drawer.Form
      className="w-30"
      show={props.show}
      backdrop={true}
      placement="end"
      scroll={true}
      title={header}
      initialValues={
        category ?? {
          communityId: props.communityId,
        }
      }
      validationSchema={validationSchema}
      enableReinitialize
      onHide={props.onHide}
      on_Submit={onSubmit}
    >
      <Form.PanelSection iconClassName="bi bi-info-circle" title="1. Basic Information">
        <Form.Text
          name="name"
          placeholder="Name"
          label="Name"
          isLoading={props.loading}
        />

        <Form.Dropdown
          name="communityId"
          label="Community"
          isLoading={props.loading}
          disabled={props.disableCommunity}
          blankOption={{
            key: Constants.emptyGuid,
            display: "Select Community",
            value: Constants.emptyString,
          }}
          options={props.lookups?.communities}
        />
        <Form.TextArea
          name="description"
          rows={3}
          label="Description"
          isLoading={props.loading}
        />
      </Form.PanelSection>

      <Form.PanelSection
        iconClassName="bi bi-calendar-event"
        title="2. Activation"
        style={{ marginTop: 16 }}
      >
        <Form.Date
          name="activationDate"
          label="Activation Date"
          placeholder="Enter date"
        />
      </Form.PanelSection>
    </Drawer.Form>
  );
};
